import React from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { Nav, NavLink, NavItem, TabContent, TabPane } from '@/components/ui-compat'
import { List, CheckSquare } from 'lucide-react'

import { useTabSwitch } from '../../hooks'
import MeetingsList from './components/MeetingsList'
import ActionItemsPanel from './components/ActionItemsPanel'

const MeetingsPage: React.FC = () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useTabSwitch('list')

  return (
    <div className="meetings-module">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold mb-0">{t('Meetings_screen_title')}</h1>
      </div>

      <div className="tab">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'list' })}
              onClick={() => setActiveTab('list')}
            >
              <List className="h-4 w-4 mr-2" />
              {t('Meetings_list_tablabel')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'actions' })}
              onClick={() => setActiveTab('actions')}
            >
              <CheckSquare className="h-4 w-4 mr-2" />
              {t('Meetings_actions_tablabel')}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="list">
            <MeetingsList />
          </TabPane>
          <TabPane tabId="actions">
            <ActionItemsPanel />
          </TabPane>
        </TabContent>
      </div>
    </div>
  )
}

export default MeetingsPage
